import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
export { Placement } from './schema/Tooltip.types';
export { ComponentClass };

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Tooltip" */ './lazyIndex'));

export let LazyTooltip = createLazyComponent(lazyModule, m => m.Tooltip);
